import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ContentChange } from 'ngx-quill';

@Component({
    selector: 'app-text-editor',
    styleUrls: ['./text-editor.component.scss'],
    templateUrl: './text-editor.component.html',
    standalone: false
})
export class TextEditorComponent implements OnInit {
  @Input() textInput: string = '';
  @Output() contentChanged = new EventEmitter<{ html: string; lines: any[] }>();

  @Input() control: FormControl;

  textForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.textForm = this.fb.group({
      editor: [''],
    });
  }

  ngOnInit(): void {
    this.textForm.get('editor').patchValue(this.textInput);
  }

  onContentChanged(event: ContentChange) {
    const quill = event.editor;
    const html = event.html;
    const lines = quill.getLines();
    this.contentChanged.emit({ html, lines });
  }

  quillConfiguration = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ],
  };
}
